module.exports = __webpack_public_path__ + "static/media/COS_LABORATOIRE_DE_BIARRITZ.6ea04240.png";